import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12 text-center mt-3" }

import { onMounted, reactive, computed } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";

type stateType = {
    id: number,
    visibleErrors: boolean,
    loader: boolean,
    password: string;
    repeatPassword: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);
const state: stateType = reactive({
    id: 0,
    visibleErrors: false,
    loader: false,
    password: '',
    repeatPassword: '',
});
onMounted(() => {
    if (Object.keys(modal.data.user).length) {
        state.id = modal.data.user.id;
    }
});

const isPasswordError = computed(() => state.password.length < 5 || !/^[a-zA-Z0-9]+$/.test(state.password));
const isRepeatPasswordError = computed(() => state.password !== state.repeatPassword);

const isErrorsExist = computed(() => {
    return isPasswordError.value || isRepeatPasswordError.value;
});

function send() {
    if (isErrorsExist.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;

    api.user.resetPassword(state.id, {
        newPassword: state.password
    }).then(r => {
        modal.ok(r.data);
    })
}


return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-md",
    title: "Редактирование данных пользователя"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Пароль состоит из не менее 5 букв или цифр",
              label: "Пароль",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.password) = $event)),
                  type: "password",
                  "is-invalid": state.visibleErrors && isPasswordError.value,
                  placeholder: "Пароль"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Значения не совпадают",
              label: "Повторно введите пароль",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2",
                  modelValue: state.repeatPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.repeatPassword) = $event)),
                  type: "password",
                  "is-invalid": state.visibleErrors && isRepeatPasswordError.value,
                  placeholder: "Повторно введите пароль"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})